module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAPBAMAAADNDVhEAAAAAXNSR0IB2cksfwAAABJQTFRFAAAATExMS0tLSkpKTU1NS0tLFpHgYwAAAAZ0Uk5TAED/wD+w6kBW2QAAAClJREFUeJxjYGAQUhJgYGBQAgMFBmMwMGBgdAEBBgYmsDj1aFYQpcoAAM1rC1KFqrPXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/images/delete_default.png
// module id = 103
// module chunks = 0